export default {"src":"/_next/static/image/public/images/ic_orderclock.0e8d67ebdee13d35afa55d74b9fffe16.svg","height":17,"width":17};